import { Subscription } from 'rxjs';
import UnifiedPlayer from '@tv2-player/unifiedplayer/src/core/UnifiedPlayer';
import larOverlayHandler from '../../handlers/larOverlay';
import { OverlayManager } from '../../overlays';
import { PluginInterface } from './PluginInterface';
import { CastReceiverContext } from '../../types/chromecast-caf-receiver/cast.framework';
import { loadRequestFilter, overlayManagerFilter, playerFilter } from '../extensions';
import { isDev } from '../../utils/env';

export class LarOverlayPlugin implements PluginInterface {
  private subscription: Subscription;

  private overlayManager: OverlayManager;

  private player: UnifiedPlayer;

  init(context: CastReceiverContext) {
    overlayManagerFilter.register(async overlayManager => {
      this.overlayManager = overlayManager;
      return overlayManager;
    });

    playerFilter.register(async player => {
      this.player = player;
      return player;
    });

    loadRequestFilter.register(async request => {
      this.subscription?.unsubscribe();
      if (isDev) {
        this.subscription = larOverlayHandler(this.overlayManager, this.player).subscribe();
      }
      return request;
    });
  }
}
